import { render, staticRenderFns } from "./Riassunto.vue?vue&type=template&id=5f113710&scoped=true&"
import script from "./Riassunto.vue?vue&type=script&lang=js&"
export * from "./Riassunto.vue?vue&type=script&lang=js&"
import style0 from "./Riassunto.vue?vue&type=style&index=0&id=5f113710&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f113710",
  null
  
)

export default component.exports